<template>
  <div>
    <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">

      <!-- Card stats -->
      <div v-if="currentProfile == 'pos_sales_dashboards'" class="row">
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Completed" type="gradient-green" :sub-title="completedStats" icon="fa fa-signal"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Success Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Pending" type="gradient-yellow" :sub-title="unprocessedStats" icon="fa fa-plug"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Unprocessed Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Error" type="gradient-red" :sub-title="errorStats" icon="fa fa-chart-line"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Errors Invoices </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-3 col-lg-6">
          <a-spin :spinning="loadingPOSSalesDashboard">
            <stats-card title="Status" type="gradient-blue" :sub-title="invoiceStatus" icon="ni ni-money-coins"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Last Run: {{ lastRun }} </span>
              </template>
            </stats-card>
          </a-spin>
        </div>
      </div>

      <div v-else-if="currentProfile == 'terminal_full_sync_details'" class="row">
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Counter" type="gradient-green" :sub-title="fullSyncCounter" icon="fa fa-signal"
            class="mb-4 mb-xl-0">
            <template slot="footer">
              <span class="mr-2"> Server Full Sync Counter </span>
              <br><br>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-4 col-lg-6">
          <stats-card title="Timestamp" type="gradient-green" :sub-title="fullSyncTimestamp" icon="fa fa-clock"
            class="mb-4 mb-xl-0">
            <template slot="footer">
              <span class="mr-2"> Server Full Sync Timestamp </span>
              <br><br>
            </template>
          </stats-card>
        </div>
      </div>

      <div v-else-if="currentProfile == 'pos_live_terminals'" class="row">
        <div class="col-xl-6 col-lg-6">
          <a-spin :spinning="loadingPosVersionDashboard">
            <stats-card title="Site" type="gradient-green" :sub-title="liveStores" icon="fa fa-store"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Live Stores </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
        <div class="col-xl-6 col-lg-6">
          <a-spin :spinning="loadingPosVersionDashboard">
            <stats-card title="Terminal" type="gradient-orange" :sub-title="liveTerminals" icon="fa fa-cash-register"
              class="mb-4 mb-xl-0">
              <template slot="footer">
                <span class="mr-2"> Total Live Terminals </span>
                <br><br>
              </template>
            </stats-card>
          </a-spin>
        </div>
      </div>

      <br><br>
      <div v-if="activeModules.length > 0">
        <base-dropdown>
          <base-button slot="title" type="success" class="dropdown-toggle">
            Barter Tools - {{ _.startCase(currentProfile) }}
          </base-button>
          <a v-for="profile in activeModules" :key="profile.id"
            @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)" class="dropdown-item"
            href="#">{{ profile.name }}</a>
        </base-dropdown>
        <base-button v-if="currentProfile == 'pos_sales_dashboards'" type="success" class="refresh-pos-data-btn"
          @click.prevent="loadPOSSalesDashboard">
          <label>
            <a-icon type="reload" />
          </label>
        </base-button>
      </div>
      <base-dropdown v-else>
        <base-button slot="title" type="success" class="dropdown-toggle">
          Barter Tools
        </base-button>
        <a class="dropdown-item" disabled>No active module/s under this feature</a>
        <!-- <a v-for="profile in activeModules" :key="profile.id" @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">{{profile.name}}</a> -->
      </base-dropdown>
      <!-- <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Tools - {{ _.startCase(currentProfile)}}
                </base-button>
                    <a @click.prevent="setCurrentProfile('pos_sessions')" class="dropdown-item" href="#">POS Sessions</a>
                    <a @click.prevent="setCurrentProfile('api_invoices')" class="dropdown-item" href="#">Api Invoices</a>
                    <a @click.prevent="setCurrentProfile('terminal_full_sync_details')" v-if="serverType == 'branch'"  class="dropdown-item" href="#">Terminal Full Sync Details</a>
                    <a @click.prevent="setCurrentProfile('terminal_delta_sync_details')" v-if="serverType == 'branch'" class="dropdown-item" href="#">Terminal Delta Sync Details</a>
                    <a @click.prevent="setCurrentProfile('branch_delta_sync_details')" v-if="serverType == 'ho'" class="dropdown-item" href="#">Branch Delta Sync Details</a>
            </base-dropdown> -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="mb-3 card" style="height: 70vh; overflow: auto;">
            <div v-if="currentProfile == 'pos_sales_dashboards'" class="row no-gutters">
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body" v-if="accessRights.includes('V')">
                  <div class="filter-bar ui basic segment grid">
                    <div class="ui form">
                      <div class="inline field">
                        <h6 class="heading-small text-muted mb-4">Search</h6>
                        <div class="input-group">
                          <div class="input-group-append">
                            <base-input alternative="" label="Business Date">
                              <br>
                              <a-date-picker :defaultValue="moment()" v-model="inputBusinessDate" :format="dateFormat" @change="formatDate" />
                            </base-input>
                          </div>
                        </div>
                        <div class="input-group ">
                          <div class="input-group-append">
                            <base-input alternative="" label="Site" inputClasses="w-100">
                              <a-select v-model="filters.siteId" @change="fetchTerminals" class="w-100" :disabled="isBranch">
                                <a-select-option key="0" value="0">All Sites</a-select-option>
                                <a-select-option v-for="site in sites" :key="site.code" :value="site.id">
                                  {{ site.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>
                        <div class="input-group ">
                          <div class="input-group-append">
                            <base-input alternative="" label="Terminal">
                              <a-select v-model="filters.terminalId"  class="w-100" >
                                <a-select-option key="0" value="0">All Terminals</a-select-option>
                                <a-select-option v-for="terminal in terminals" :key="terminal.code" :value="terminal.id">
                                  {{ terminal.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>

                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                        <div>
                          <base-radio name="0" class="mb-3" v-model="filters.status" value="O">
                            All
                          </base-radio>
                          <base-radio name="C" class="mb-3" v-model="filters.status" value="C">
                            Completed
                          </base-radio>
                          <base-radio name="E" class="mb-3" v-model="filters.status" value="E">
                            Error
                          </base-radio>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body" v-if="accessRights.includes('V')">
                  <api-invoices-table v-if="currentProfile == 'pos_sales_dashboards'" :status="filterStatus" :accessRights="accessRights"></api-invoices-table>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>
            </div>

            <!-- <div v-else-if="(currentProfile=='terminal_full_sync_details' ||  currentProfile=='terminal_delta_sync_details') && serverType == 'branch' " class="row no-gutters"> -->
            <div
              v-else-if="(currentProfile == 'terminal_full_sync_details' || currentProfile == 'terminal_delta_sync_details')"
              class="row no-gutters">
              <div class="col-md-12" v-if="accessRights.includes('V')">
                <div class="card-body">
                  <terminal-full-sync-details-table v-if="currentProfile == 'terminal_full_sync_details'">
                  </terminal-full-sync-details-table>
                  <terminal-delta-sync-details-table v-else-if="currentProfile == 'terminal_delta_sync_details'">
                  </terminal-delta-sync-details-table>
                </div>
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'branch_delta_sync_details')" class="no-gutters">
              <div class="card-body" v-if="accessRights.includes('V')">
                <branch-delta-sync-details-table v-if="currentProfile == 'branch_delta_sync_details'"
                  :key="componentKey"></branch-delta-sync-details-table>
              </div>
              <div class="card-body" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'offline_tools')" class="no-gutters">
              <offline-tool v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'cash_movements')" class="no-gutters">
              <cash-movement v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'job_monitorings')" class="no-gutters">
              <jobs-table v-if="accessRights.includes('V')" :key="componentKey" />
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'pos_versions')" class="row no-gutters">
<!--              <pos-versions-table v-if="accessRights.includes('V')" :key="componentKey" />-->
              <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                <div class="card-body" v-if="accessRights.includes('V')">
                  <div class="filter-bar ui basic segment grid">
                    <div class="ui form">
                      <div class="inline field">
                        <h6 class="heading-small text-muted mb-4">Search</h6>
                        <div class="input-group">
                          <div class="input-group-append">
                            <base-input alternative="" label="Site" inputClasses="w-100">
                              <a-select v-model="filters.siteId" @change="fetchTerminals" class="w-100" :disabled="isBranch" option-filter-prop="children" showSearch>
                                <a-select-option key="0" value="0">All Sites</a-select-option>
                                <a-select-option v-for="site in sites" :key="site.code" :value="site.id">
                                  {{ site.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>
                        <div class="input-group ">
                          <div class="input-group-append">
                            <base-input alternative="" label="Terminal">
                              <a-select v-model="filters.terminalId" option-filter-prop="children" showSearch class="w-100" >
                                <a-select-option key="0" value="0">All Terminals</a-select-option>
                                <a-select-option v-for="terminal in terminals" :key="terminal.code" :value="terminal.id">
                                  {{ terminal.name }}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                        </div>

                        <hr class="my-4" />
                        <h6 class="heading-small text-muted mb-4">Filter by status</h6>
                        <div>
                          <base-radio name="0" class="mb-3" v-model="filters.status" value="O">
                            All
                          </base-radio>
                          <base-radio name="A" class="mb-3" v-model="filters.status" value="A">
                            Active
                          </base-radio>
                          <base-radio name="I" class="mb-3" v-model="filters.status" value="I">
                            Inactive
                          </base-radio>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>

              <div class="col-md-9">
                <div class="card-body" v-if="accessRights.includes('V')">
                   <pos-versions-table :key="componentKey" :accessRights="accessRights"/>
                </div>
                <div class="card-body" v-else>
                  <a-empty class='mt-5' :image-style="{ height: '50px', }">
                    <span slot="description"> No access </span>
                  </a-empty>
                </div>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'sales_resender_tools')" class="row no-gutters">
              <div class="w-100" v-if="accessRights.includes('V')">
                <sales-resender :key="componentKey" />
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else-if="(currentProfile == 'pde_viewing_tools')" class="row no-gutters">
              <div class="w-100" v-if="accessRights.includes('V')">
                <pde-viewing-tool :key="componentKey" />
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>
            <div v-else-if="(currentProfile == 'pos_live_terminals')" class="row no-gutters">
              <div class="w-100" v-if="accessRights.includes('V')">
                <live-terminals-table :key="componentKey" />
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

            <div v-else class="row no-gutters">
              <div class="card-body" v-if="accessRights.includes('V')">
                <pos-sessions-table v-if="currentProfile == 'pos_declarations'" :accessRights="accessRights"
                  :key="componentKey"></pos-sessions-table>
              </div>
              <div class="col-md-12" v-else>
                <a-empty class='mt-5' :image-style="{ height: '50px', }">
                  <span slot="description"> No access </span>
                </a-empty>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfflineTool from './Tools/OfflineTool.vue'
import CashMovement from './Tools/CashMovement.vue'
import SalesResender from './Tools/SalesResender.vue'
import PdeViewingTool from './Tools/PdeViewingTool.vue'
import PosSessionsTable from './Tables/PosSessionsTable.vue'
import ApiInvoicesTable from './Tables/ApiInvoicesTable.vue'
import TerminalFullSyncDetailsTable from './Tables/TerminalFullSyncDetailsTable.vue'
import TerminalDeltaSyncDetailsTable from './Tables/TerminalDeltaSyncDetailsTable.vue'
import BranchDeltaSyncDetailsTable from './Tables/BranchDeltaSyncDetailsTable.vue'
import JobsTable from './Jobs.vue'
import PosVersionsTable from "./Tables/PosVersionsTable.vue";
import LiveTerminalsTable from "./Tables/LiveTerminalsTable.vue";

import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from './../controllers/secureStorage';
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

export default {
  data() {
    return {
      searchFilter: "DATE(businessDate)",
      sessionStats: "0",
      filterStatus: "0",
      inputProfile: '',
      filterSyncStatus: "0",
      dateFormat: 'MM-DD-YYYY',
      inputBusinessDate: moment(),
      formatBusinessDate: moment().format('YYYY-MM-DD'),
      completedStats: "0",
      fullSyncCounter: '',
      fullSyncTimestamp: '',
      unprocessedStats: "0",
      errorStats: "0",
      invoiceStatus: "Stopped",
      lastRun: "",
      activeModules: [],
      accessRights: [],
      profileId: null,
      componentKey: 0,
      formKey: 0,
      loadingPOSSalesDashboard: false,
      sites: [],
      terminals: [],
      filters: {
        businessDate: '',
        siteId: secureStorage.getItem("defaultSiteId"),
        terminalId: '0',
        status: '0',
      },
      isBranch: secureStorage.getItem("currentSiteSiteType") == 'branch' ? true : false,
      liveStores: "0",
      liveTerminals: "0",
      loadingPosVersionDashboard: false,
    }
  },
  mounted: async function () {
    // siteType = secureStorage.getItem("currentSiteSiteType");
    // isBranch = secureStorage.getItem("currentSiteSiteType") == 'branch' ? true : false;
    // console.log("site id: " + secureStorage.getItem("defaultSiteId"));

    var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=P-002', null, null)
    this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)

    if (this.activeModules.length > 0) {
      // if(this.currentProfile != 'pos_sales_dashboards' && this.currentProfile != 'terminal_delta_sync_details' && this.currentProfile != 'branch_delta_sync_details'){
      var profile = _.snakeCase(this.activeModules[0].name)
      this.setCurrentProfile(_.pluralize(profile), this.activeModules[0].id);
      // }
    } else {
      this.setCurrentProfile(null, null);
    }

    if (this.currentProfile == "pos_sales_dashboards") {
      this.loadPOSSalesDashboard();
      // this.formatBusinessDate = null
      // if (this.inputBusinessDate != null) {
      //     this.formatBusinessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')
      // } else {
      //     this.formatBusinessDate = moment().format('YYYY-MM-DD')
      // }

      // var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.formatBusinessDate , null)
      // this.completedStats =  '' + stats["no_of_completed"] + '';
      // this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
      // this.errorStats = '' + stats["no_of_error"] + '';
      // this.invoiceStatus = stats["invoice_status"];
      // this.lastRun = moment(stats["last_run"]);
      // this.setProfileId(stats["setting_id"]);

      // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)
    } else if (this.currentProfile == "terminal_full_sync_details") {
      var full_sync_detail = await HTTPRequest.getRequest(this.endPoint + "terminal_full_sync_details/server_full_sync_detail", null)
      this.fullSyncCounter = full_sync_detail.server_full_sync_counter.toString()
      this.fullSyncTimestamp = full_sync_detail.server_full_sync_timestamp
    } else if (this.currentProfile == "pos_versions") {
      this.fetchLiveStoresAndTerminals();
    } else if (this.currentProfile == "pos_live_terminals") {
       this.fetchLiveStoresAndTerminals();
    }

  },
  watch: {
    filters: {
      handler() {
        this.changeFilter(this.filters);
      },
      deep: true
    },
    filterSyncStatus: function () {
      if (this.currentProfile == "branch_delta_sync_details") {
        this.changeSyncFilter(this.filterSyncStatus, 'profile', this.inputProfile)
      } else {
        this.changeSyncFilter(this.filterSyncStatus, 'code', this.inputTerminalName)
      }
    },
    currentProfile: async function () {
      if (this.currentProfile == "pos_sales_dashboards") {
        this.loadPOSSalesDashboard();
        // this.formatBusinessDate = null
        // if (this.inputBusinessDate != null) {
        //     this.formatBusinessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')
        // }
        // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)

        // var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.formatBusinessDate , null)
        // this.completedStats =  '' + stats["no_of_completed"] + '';
        // this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
        // this.errorStats = '' + stats["no_of_error"] + '';
        // this.invoiceStatus = stats["invoice_status"];
        // this.lastRun = moment(stats["last_run"]);
        // this.setProfileId(stats["setting_id"]);
      } else if (this.currentProfile == "terminal_full_sync_details") {
        var full_sync_detail = await HTTPRequest.getRequest(this.endPoint + "terminal_full_sync_details/server_full_sync_detail", null)
        this.fullSyncCounter = full_sync_detail.server_full_sync_counter.toString()
        this.fullSyncTimestamp = full_sync_detail.server_full_sync_timestamp
      } else if (this.currentProfile == "pos_versions") {
        this.fetchLiveStoresAndTerminals();
        this.sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
        this.fetchTerminals();
      } else if (this.currentProfile == "pos_live_terminals") {
        this.fetchLiveStoresAndTerminals();
        this.sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
        this.fetchTerminals();
      }
    },
    parameters: async function () {
      if (this.currentProfile == "pos_sales_dashboards") {
        // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)
        // console.log(this.filters);
        // if (this.formatBusinessDate == null) {
        //   this.formatBusinessDate = "";
        // }
        // this.filters.businessDate = this.formatBusinessDate

        var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.filters.businessDate, null)
        this.completedStats = '' + stats["no_of_completed"] + '';
        this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
        this.errorStats = '' + stats["no_of_error"] + '';
        this.invoiceStatus = stats["invoice_status"];
        this.lastRun = moment(stats["last_run"]);
        this.setProfileId(stats["setting_id"]);
      }
    }
  },
  computed: {
    ...mapState(['currentProfile', 'parameters', 'serverType', 'endPoint', 'profileId'])
  },
  components: {
    JobsTable, CashMovement, SalesResender, PdeViewingTool, PosSessionsTable, ApiInvoicesTable, TerminalFullSyncDetailsTable, TerminalDeltaSyncDetailsTable, BranchDeltaSyncDetailsTable, OfflineTool, PosVersionsTable,
    LiveTerminalsTable
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters', 'updateProfileId']),
    moment,
    async setCurrentProfile(profile, id) {
      this.updateCurrentProfile(profile);
      this.inputTerminalName = null;
      this.inputBusinessDate = moment();
      this.filters.status = "0"
      this.filterSyncStatus = "0"

      this.profileId = id
      var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
      if (_.isEmpty(accessRightsRequest.access_rights) == false) {
        this.accessRights = accessRightsRequest.access_rights[id]
      } else {
        this.accessRights = []
      }

      this.componentKey++;
      this.formKey++;

      // console.log(profile);
      // console.log("---------------")
      // console.log(this.accessRights)

    },
    setProfileId(id) {
      this.updateProfileId(id)
    },
    changeFilter(filters) {
      let paramText = '';
      if (this.currentProfile == "pos_versions") {
        filters["account_id"] = secureStorage.getItem("accountId")
        delete filters["businessDate"]
      }
      for (const filter in filters) {
        if (filters[filter] && filters[filter] !== '0') {
          paramText += paramText.length ? '&' : '?';
          switch (filter) {
            case 'businessDate':
              paramText += `DATE(business_date)=${filters[filter]}`
              break;

            default:
              paramText += `${_.snakeCase(filter)}=${filters[filter]}`
              break;
          }
        }
      }
      console.log('parameters: ' + paramText);
      this.updateParameters(paramText);
    },
    changeSyncFilter(statusFilter, searchFilter, searchText) {
      if (searchText == null) {
        if (statusFilter == "0") {
          this.updateParameters('/')
        } else if (statusFilter == "Y") {
          this.updateParameters("?sync_status=Y")
        } else {
          this.updateParameters("?sync_status=N")
        }
      } else {
        if (statusFilter == "0") {
          this.updateParameters("?" + searchFilter + "=" + searchText)
        } else if (statusFilter == "Y") {
          this.updateParameters("?" + searchFilter + "=" + searchText + "&sync_status=Y")
        } else {
          this.updateParameters("?" + searchFilter + "=" + searchText + "&sync_status=N")
        }
      }
    },
    onSyncChange() {
      if (this.currentProfile == "branch_delta_sync_details") {
        this.changeSyncFilter(this.filterSyncStatus, 'profile', this.inputProfile)
      } else {
        this.changeSyncFilter(this.filterSyncStatus, 'code', this.inputTerminalName)
      }
    },
    loadPOSSalesDashboard: async function () {
      this.loadingPOSSalesDashboard = true;
      // if (isBranch) this.filters.siteId = secureStorage.getItem("defaultSiteId");
      this.formatDate();


      var stats = await HTTPRequest.getRequest(this.endPoint + "api_invoices/get_stats?business_date=" + this.filters.businessDate, null)
      this.completedStats = '' + stats["no_of_completed"] + '';
      this.unprocessedStats = '' + stats["no_of_unprocessed"] + '';
      this.errorStats = '' + stats["no_of_error"] + '';
      this.invoiceStatus = stats["invoice_status"];
      this.lastRun = moment(stats["last_run"]);
      this.setProfileId(stats["setting_id"]);

      let sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + secureStorage.getItem("userId"), null);
      this.sort(sites);
      this.sites = sites;
      this.fetchTerminals();

      // this.changeFilter(this.filters.status, this.searchFilter, this.formatBusinessDate)
      this.loadingPOSSalesDashboard = false;
    },
    async fetchTerminals() {
      this.filters.terminalId = "0"
      // Returns all valid terminals for account if site_id = "0"
      this.terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + this.filters.siteId, null);
    },
    formatDate() {
      if (this.inputBusinessDate != null) {
        this.filters.businessDate = moment(this.inputBusinessDate).format('YYYY-MM-DD')

      } else {
        this.filters.businessDate = ''
      }
      // this.filters.businessDate = this.formatBusinessDate
    },
    fetchLiveStoresAndTerminals: async function () {
      this.loadingPosVersionDashboard = true;
      var liveSites = await HTTPRequest.getRequest(this.endPoint + "sites/get_all_live_sites", null)
      this.liveStores = '' + liveSites.count + '';
      var liveTerminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_all_live_terminals", null)
      this.liveTerminals = '' + liveTerminals.count + '';
      this.loadingPosVersionDashboard = false;
    },
    sort(data){
      data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
      });
    },
}
}
</script>

<style scoped>
.refresh-pos-data-btn {
  font-size: 20px;
}

.refresh-pos-data-btn label {
  display: flex;
  margin-bottom: 0;
  cursor: pointer;
}

.ant-calendar-picker, .input-group-append, .form-group {
  width: 100%;
}
</style>
